// Sample purchase history for the contact Overview tab (CRM-style call prep)
// Full order history lives in data/mockContactOrders.ts

export interface TopProduct {
  id: string;
  title: string; // includes the vintage, e.g. "2021 Barossa Shiraz"
  timesOrdered: number;
  lastOrdered: string; // YYYY-MM-DD
}

export const contactTopProducts: TopProduct[] = [{
  id: 'tp-1',
  title: '2021 Barossa Shiraz',
  timesOrdered: 9,
  lastOrdered: '2026-09-12'
}, {
  id: 'tp-2',
  title: '2023 Eden Valley Riesling',
  timesOrdered: 7,
  lastOrdered: '2026-09-12'
}, {
  id: 'tp-3',
  title: '2022 McLaren Vale Grenache',
  timesOrdered: 6,
  lastOrdered: '2026-06-16'
}, {
  id: 'tp-4',
  title: '2020 Coonawarra Cabernet Sauvignon',
  timesOrdered: 4,
  lastOrdered: '2026-03-19'
}, {
  id: 'tp-5',
  title: '2023 Adelaide Hills Chardonnay',
  timesOrdered: 3,
  lastOrdered: '2025-12-20'
}];

// Plain-English summary shown at the top of the Overview
export const contactSummaryLines: string[] = ['Orders roughly every 3 months', 'Member for 4 years, 12 renewals', 'Skipped 3 times and paused once in the last 12 months'];
